/** @format */

import React from 'react';

const RemoveObstaclesIcon = (): JSX.Element => {
  return (
    <>
      <svg width="56px" height="56px" viewBox="0 0 56 56">
        <g
          id="remove-obstacles-icon"
          stroke="#000000"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round">
          <g
            id="Group-17"
            transform="translate(3.000000, 7.000000)"
            strokeWidth="2">
            <path
              d="M22.0578947,27.7802984 L22.0578947,3.95279048 C22.0578947,1.86829841 23.7822368,0.162568254 25.8894737,0.162568254 C27.9967105,0.162568254 29.7210526,1.86829841 29.7210526,3.95279048 L29.7210526,23.2247429"
              id="Stroke-1"
              stroke="#000000"></path>
            <path
              d="M22.0578947,23.1834825 L22.0578947,36.5982921 C22.0578947,38.6827841 20.3335526,40.3885143 18.2263158,40.3885143 C16.1190789,40.3885143 14.3947368,38.6827841 14.3947368,36.5982921 L14.3947368,22.229419"
              id="Stroke-3"
              stroke="#000000"></path>
            <path
              d="M37.3841447,22.2294841 L37.3841447,27.187881 C37.3841447,29.272373 35.6598026,30.9774524 33.5525658,30.9774524 C31.4453289,30.9774524 29.7209868,29.272373 29.7209868,27.187881 L29.7209868,21.5825952"
              id="Stroke-5"
              stroke="#000000"></path>
            <path
              d="M8.18269737,18.4391317 L10.5636184,18.4391317 C12.6708553,18.4391317 14.3945395,20.1448619 14.3945395,22.229354"
              id="Stroke-7"
              stroke="#00A9E0"></path>
            <path
              d="M48.8597368,18.4391317 L41.2156579,18.4391317 C39.1084211,18.4391317 37.3840789,20.1448619 37.3840789,22.229354"
              id="Stroke-9"
              stroke="#00A9E0"></path>
            <path
              d="M8.18269737,18.4391317 C8.18269737,20.6297032 6.38730263,22.4050683 4.17348684,22.4050683 C1.95967105,22.4050683 0.164276316,20.6297032 0.164276316,18.4391317 C0.164276316,16.2492111 1.95967105,14.4731952 4.17348684,14.4731952 C6.38730263,14.4731952 8.18269737,16.2492111 8.18269737,18.4391317 Z"
              id="Stroke-11"
              stroke="#00A9E0"></path>
            <path
              d="M45.9098026,14.3647079 L49.8657237,18.278581"
              id="Stroke-13"
              stroke="#00A9E0"></path>
            <path
              d="M45.9098026,22.2549302 L49.8657237,18.3417079"
              id="Stroke-15"
              stroke="#00A9E0"></path>
          </g>
        </g>
      </svg>
    </>
  );
};
export default RemoveObstaclesIcon;
